
const setOnline = (state) => {
    state.online = true
}

const setOffline = (state) => {
    state.online = false
}

const updateData = (state, data) => {
    let original = state.data
    state.data = { ...original, ...data }
}

export default {
    setOnline,
    setOffline,
    updateData,
}
